<template>
  <v-dialog v-model="value" @click:outside="outside" max-width="290">
    <h1 class="help-header">ヘルプ</h1>
    <v-container fluid class="help-container">
      <v-row no-gutters>
        <v-col cols="3" class="done-help-icon"
          ><h2 class="done-help-icon-title">完了</h2>
        </v-col>
        <v-col cols="9"
          ><p class="ml-2">
            もう覚えたなという単語は、この「完了」ボタンを押しましょう。今後はテストでは出てきません。
          </p>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="3" class="correct-help-icon"
          ><h2 class="correct-help-icon-title">正解</h2>
        </v-col>
        <v-col cols="9"
          ><p class="ml-2">
            このテストでは「正解」したけど、まだ完全には暗記していないと思う単語は、この「正解」ボタンを押しましょう。今後もテストに出てきます。
          </p>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="3" class="wrong-help-icon"
          ><h2 class="wrong-help-icon-title">不正解</h2>
        </v-col>
        <v-col cols="9"
          ><p class="ml-2">
            このテストで分からなかった単語は「不正解」ボタンを押しましょう。今後もテストに出てきます。
          </p>
        </v-col>
      </v-row>
    </v-container>
    <v-btn
      color="primary"
      width="100%"
      height="40px"
      dark
      @click="closeHelpDialog"
    >
      閉じる
    </v-btn>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
    },
  },
  data: function () {
    return {};
  },
  watch: {},
  computed: {},
  methods: {
    closeHelpDialog() {
      this.$emit("close");
    },
    outside(e) {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.help-header {
  background: #ff6663;
  color: white;
  font-weight: bold;
  font-size: 20px;
  text-align: center;
  height: 50px;
  line-height: 50px;
}
.help-container {
  background: white;
}
.done-help-icon {
  background: #e4b363;
  height: 65px;
  width: 65px;
  border-radius: 8px;
}
.done-help-icon-title {
  color: white;
  text-align: center;
  line-height: 65px;
}
.correct-help-icon {
  background: #ff6663;
  height: 65px;
  width: 65px;
  border-radius: 8px;
}
.correct-help-icon-title {
  color: white;
  text-align: center;
  line-height: 65px;
}
.wrong-help-icon {
  background: #39a0ed;
  height: 65px;
  width: 65px;
  border-radius: 8px;
}
.wrong-help-icon-title {
  color: white;
  font-size: 1.2em;
  text-align: center;
  line-height: 65px;
}
</style>
